module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm1"
  }, [_c('span', [_c('i', [_vm._v("From far, from eve and morning")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', [_c('i', [_vm._v("And yon twelve-winded sky")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', [_c('i', [_vm._v("The stuff of life to knit me")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', [_c('i', [_vm._v("Blew hither: here am I")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "fm3"
  }, [_c('span', [_c('i', [_vm._v("Now—for a breath I tarry")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', [_c('i', [_vm._v("Nor yet disperse apart")]), _vm._v("—")])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', [_c('i', [_vm._v("Take my hand quick and tell me")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', [_c('i', [_vm._v("What have you in your heart")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "fm3"
  }, [_c('span', [_c('i', [_vm._v("Speak now, and I will answer;")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', [_c('i', [_vm._v("How shall I help you, say;")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', [_c('i', [_vm._v("Ere to the wind’s twelve quarters")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', [_c('i', [_vm._v("I take my endless way")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', [_vm._v("—"), _c('i', [_vm._v("A. E. Housman")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41133b6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter01.vue
// module id = 69
// module chunks = 0